export const rankShare = (num) => {
  switch (num) {
    case '1':
      return '<img src="../../static/img/icon_sign_first.png" alt="">'
    case '2':
      return '<img src="../../static/img/icon_sign_second.png" alt="">'
    case '3':
      return '<img src="../../static/img/icon_sign_third.png" alt="">'
    default:
      return num
  }
}



// WEBPACK FOOTER //
// ./src/filters/rank_Share.js